(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7866],{

/***/ 1866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v2_ProductTile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(72433);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./src/components/core/Checkbox/Checkbox.jsx
var Checkbox = __webpack_require__(55511);
// EXTERNAL MODULE: ./src/components/core/Highlight/Highlight.jsx
var Highlight = __webpack_require__(293);
// EXTERNAL MODULE: ./src/components/core/ToolTip/ToolTip.jsx
var ToolTip = __webpack_require__(45138);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./src/components/Shared/ProductSocialShare/v1/ProductSocialShare.jsx
var ProductSocialShare = __webpack_require__(11059);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./src/hooks/useWindowResize.js
var useWindowResize = __webpack_require__(18216);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./constants/index.js + 2 modules
var constants = __webpack_require__(47956);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(5702);
// EXTERNAL MODULE: ./src/store/features/searchSlice.js
var searchSlice = __webpack_require__(54127);
// EXTERNAL MODULE: ./src/store/features/authSlice.js
var authSlice = __webpack_require__(2693);
;// CONCATENATED MODULE: ./src/components/ProductList/v2/ProductTile/localization.js
const getTranslations = (t)=>{
    return {
        familyResults: t("kf.viewFamilyResults"),
        viewSterlingResults: t("kf.viewSterlingResults")
    };
};

// EXTERNAL MODULE: ./public/images/swatch-missing.jpeg
var swatch_missing = __webpack_require__(36562);
// EXTERNAL MODULE: ./public/icons/share.svg
var share = __webpack_require__(66773);
// EXTERNAL MODULE: ./public/icons/wish.svg
var wish = __webpack_require__(29875);
// EXTERNAL MODULE: ./public/icons/wishlist-gray-filled.svg
var wishlist_gray_filled = __webpack_require__(62084);
// EXTERNAL MODULE: ./store/features/compareSlice.js
var compareSlice = __webpack_require__(39915);
;// CONCATENATED MODULE: ./components/ProductList/v2/ProductTile/index.jsx






























const ProductTile = (props)=>{
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = getTranslations(t);
    const { data , texts , lite , loading , addToCompare , removeFromCompare , highlightText , hideCompare , currencySign , isGrouped , rowCols , presetConfigs ="{}" , isPartsDiagramLinkVisible =false , swatchCount , plpPage , defaultImage , hoverImage , mapImageToColor , currFilters , favorites , exactSKU , type ="" , selectedtab , handleOnClickPartsDiagramLink , favPage , index , selectedSort , onToggle , isSearchPanelTile , isSterling =false , sterlingData =[] , showSterlingButton =false , parent ="" , plpBadge ={} , searchPagePath ="" , saleInfo =[]  } = props;
    console.log("ProductTile texts", texts);
    console.log("data", data);
    console.log("defaultImage", defaultImage);
    console.log("hoverImage", hoverImage);
    const { plpBadges ={} , displayOrderBadgeList =[]  } = plpBadge;
    const router = (0,next_router.useRouter)();
    const { isAuth , access_token: accessToken  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { toaster  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { searchPresetConfigs  } = (0,es/* useSelector */.v9)(searchSlice/* searchState */.uv);
    const [general, setGeneral] = (0,react.useState)({
        swatchUrl: "https://kohler.scene7.com/is/image/PAWEB/",
        siteName: "Kohler"
    });
    const [tileUrl, setTileUrl] = (0,react.useState)("");
    const [locale, setLocale] = (0,react.useState)("en-US");
    const [badgesList, setBadgesList] = (0,react.useState)([]);
    const [width] = (0,useWindowResize/* default */.Z)();
    const [toasterContent, setToasterContent] = (0,react.useState)({
        successMessage: "",
        unfavoriteSuccessMessage: ""
    });
    const [isChecked, setIsChecked] = (0,react.useState)(false);
    const [showShare, setShowShare] = (0,react.useState)(false);
    const [errorMessage, setErrorMessage] = (0,react.useState)("");
    const [onHover, setOnHover] = (0,react.useState)(false);
    const [hoverColor, setHoverColor] = (0,react.useState)({});
    const [selectedColor, setSelectedColor] = (0,react.useState)({});
    const EMPTY_PIXEL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    const [sku, setSku] = (0,react.useState)("");
    const [masterCustomerFacingSku, setMasterCustomerFacingSku] = (0,react.useState)("");
    const [productCategory, setProductCategory] = (0,react.useState)("");
    const [colorDetail, setColorDetail] = (0,react.useState)([]);
    const [colorCount, setColorCount] = (0,react.useState)("");
    const [persona, setPersona] = (0,react.useState)("");
    const [images, setImages] = (0,react.useState)([]);
    const dispatch = (0,es/* useDispatch */.I0)();
    const [selColor, setSelColor] = (0,react.useState)("");
    const [variantPrice, setVariantPrice] = (0,react.useState)(0);
    const [variantDiscPrice, setVariantDiscPrice] = (0,react.useState)(0);
    const [colors, setColors] = (0,react.useState)([
        {}
    ]);
    const [selSku, setSelSku] = (0,react.useState)("");
    const [selCustomerFacingSKU, setSelCustomerFacingSKU] = (0,react.useState)("");
    const [tileTitle, setTileTitle] = (0,react.useState)("");
    const [productName, setProductName] = (0,react.useState)("");
    const [productDescription, setProductDescription] = (0,react.useState)("");
    const [description, setDescription] = (0,react.useState)("");
    const [category, setCategory] = (0,react.useState)("");
    const [shipmentDate, setShipmentDate] = (0,react.useState)("");
    const [badgeVal, setBadgeVal] = (0,react.useState)("");
    const [discountedPrice, setDiscountedPrice] = (0,react.useState)(0);
    const [finalPrice, setFinalPrice] = (0,react.useState)(0);
    const [price, setPrice] = (0,react.useState)(0);
    const [isFavorite, setIsFavorite] = (0,react.useState)(false);
    const [isDiscountedPrice, setIsDiscountedPrice] = (0,react.useState)(0);
    const [detaultSelectedColor, setDetaultSelectedColor] = (0,react.useState)("");
    const [defaultCustomerFacingSku, setDefaultCustomerFacingSku] = (0,react.useState)("");
    const [defaultImageTmp, setDefaultImageTmp] = (0,react.useState)("");
    const [defaultProductIsInStock, setDefaultProductIsInStock] = (0,react.useState)(false);
    const [discountPercent, setDiscountPercent] = (0,react.useState)(0);
    const [discountPriceState, setDiscountPriceState] = (0,react.useState)(0);
    const [productIsRetail, setProductIsRetail] = (0,react.useState)(false);
    const [isSuperSku, setIsSuperSku] = (0,react.useState)(false);
    const [discountAmount, setDiscountAmount] = (0,react.useState)(0);
    const [productSaleable, setProductSaleable] = (0,react.useState)(true);
    const [productRoom, setProductRoom] = (0,react.useState)("");
    const [productCollectionsName, setProductCollectionsName] = (0,react.useState)("");
    const [maxPrice, setMaxPrice] = (0,react.useState)(0);
    const [discountedMaxPrice, setDiscountedMaxPrice] = (0,react.useState)(0);
    const triggerAnalytics = (0,react.useRef)(null);
    const [loginFavouriteCallback, setLoginFavouriteCallback] = (0,react.useState)(null);
    const [isMobile, setIsMobile] = (0,react.useState)(width <= 1203);
    const { comparedProducts , category: compareCategory , isEnable , compareSectionData  } = (0,es/* useSelector */.v9)(compareSlice/* compareState */.NP);
    const [isSale, setIsSale] = (0,react.useState)(false);
    const [unit, setUnit] = (0,react.useState)("");
    const { primaryBundleSKU_s: primaryBundleSKUs = "" , RegionAltUOM_s: RegionUOM = ""  } = data;
    const CharacteristicDescription = get_default()(data, "ItemCharacteristic.TYPE.CharacteristicDescriptionUpperCase_s", "");
    (0,react.useEffect)(()=>{
        setIsMobile(width <= 1023);
    }, [
        width
    ]);
    (0,react.useEffect)(()=>{
        const selectedSkuSaleDetails = (selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.sku) ? saleInfo === null || saleInfo === void 0 ? void 0 : saleInfo.find((saleDetail)=>{
            return (saleDetail === null || saleDetail === void 0 ? void 0 : saleDetail.split("|")[0]) === (selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.sku);
        }) : saleInfo[0];
        if (selectedSkuSaleDetails && (selectedSkuSaleDetails === null || selectedSkuSaleDetails === void 0 ? void 0 : selectedSkuSaleDetails.split("|")[1]) === "Yes") {
            setIsSale(true);
        }
    }, [
        saleInfo,
        selectedColor
    ]);
    const handleFavorite = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        window.preActiveElement = e.target;
        if (isFavorite === true) {
            favorites === null || favorites === void 0 ? void 0 : favorites.map((fav)=>{
                if (fav.productId === data["ctId_s"]) {
                    if (!isAuth) {
                        handleLogin(e);
                    } else {
                        dispatch((0,favoritesSlice/* removeItems */.Er)({
                            ids: [
                                fav.id
                            ],
                            isDataLayerNeeded: false
                        })).unwrap().then(()=>{
                            handleCallBack("success", texts.removeItem);
                            dispatch((0,genericSlice/* showToast */.CF)({
                                message: toasterContent.unfavoriteSuccessMessage || texts.removeItem,
                                isVisible: true
                            }));
                        }).catch((err)=>{
                            dispatch((0,genericSlice/* showToast */.CF)({
                                message: texts.removeItemError,
                                isVisible: true
                            }));
                            handleCallBack("failure", texts.removeItemError);
                        });
                    }
                }
            });
        } else {
            if (!isAuth) {
                handleLogin(e);
            } else {
                dispatch((0,favoritesSlice/* addProduct */.gK)((selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.sku) ? selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.sku : sku)).unwrap().then(()=>{
                    handleCallBack("success", texts.favSuccessMsg);
                    dispatch((0,genericSlice/* showToast */.CF)({
                        message: toasterContent.successMessage || texts.favSuccessMsg,
                        isVisible: true
                    }));
                }).catch((err)=>{
                    dispatch((0,genericSlice/* showToast */.CF)({
                        message: texts.favErrorMsg,
                        isVisible: true
                    }));
                    handleCallBack("failure", texts.favErrorMsg);
                });
            }
        }
        window.loginFavouriteCallback = null;
        setLoginFavouriteCallback(null);
    };
    const handleCallBack = (status, message)=>{
        var ref;
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        let isForSample = false;
        if (page && (page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.subCategory1)) {
            const { category: { subCategory1  }  } = page;
            isForSample = subCategory1.includes("samples");
        }
        const eventInfo = getEventInfo("favorite", null, true, isForSample);
        const productInfo = getProductInfo(selectedColor, true);
        eventInfo.eventStatus = status;
        eventInfo.eventMsg = (0,helper/* sanitizeTextForAnalytics */.T68)(message);
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo,
            productInfo
        });
    };
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then((config)=>{
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
            setLocale(get_default()(config, "internationalization.locale", ""));
        });
        setToasterMessage();
        setUnit((0,helper/* getUnitType */.rYX)(RegionUOM, texts, CharacteristicDescription));
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(accessToken)) {
            setPersona((0,helper/* getUserPersona */.shu)());
        }
    }, [
        accessToken
    ]);
    (0,react.useEffect)(()=>{
        if (loginFavouriteCallback && isAuth) {
            handleFavorite(loginFavouriteCallback);
        }
    }, [
        loginFavouriteCallback,
        isAuth
    ]);
    (0,react.useEffect)(()=>{
        if (selectedColor && triggerAnalytics.current) {
            colorClickHandler(selectedColor);
        }
    }, [
        selectedColor
    ]);
    const setToasterMessage = async ()=>{
        if (!isEmpty_default()(toaster === null || toaster === void 0 ? void 0 : toaster.content)) {
            const { successMessage , unfavoriteSuccessMessage  } = toaster.content;
            setToasterContent({
                successMessage: await (0,helper/* getShortenedUrl */.Ppy)(successMessage),
                unfavoriteSuccessMessage: await (0,helper/* getShortenedUrl */.Ppy)(unfavoriteSuccessMessage)
            });
        }
    };
    (0,react.useEffect)(()=>{
        let tempSku = data["masterSKU_s"];
        if (data["sku_s"]) {
            tempSku = data["sku_s"];
        }
        setSku(tempSku);
        setProductCategory(get_default()(data, "Product_Category", ""));
    }, [
        data
    ]);
    const isBundleProduct = false;
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(persona)) {
            var ref;
            setColorDetail((ref = data["Color.".concat(persona, ".Details_ss")]) !== null && ref !== void 0 ? ref : []);
        }
    }, [
        data,
        persona
    ]);
    (0,react.useEffect)(()=>{
        if (!sku) return;
        let imagestmp = [];
        const productVariantImages = data["productImages.labelWithUrl_ss"];
        let setDefaultProductImage = "";
        let setHoverProductImage = "";
        let isHover = true;
        if ((productVariantImages === null || productVariantImages === void 0 ? void 0 : productVariantImages.length) > 0) {
            const variantImages = productVariantImages.filter((img)=>sku === img.split("|")[0]);
            if (plpPage) {
                variantImages.find((img)=>{
                    const imgDetails = img.split("|");
                    if (imgDetails[2] === defaultImage) return setDefaultProductImage = imgDetails[1];
                    else setDefaultProductImage = variantImages[0].split("|")[1];
                });
                productVariantImages.find((img)=>{
                    const imgDetails = img.split("|");
                    if (imgDetails[2] === hoverImage) return setHoverProductImage = imgDetails[1];
                });
            } else {
                productVariantImages.find((img)=>{
                    const imgDetails = img.split("|");
                    if (sku === imgDetails[0]) return setDefaultProductImage = imgDetails[1];
                });
            }
            imagestmp.push(setDefaultProductImage);
            if (plpPage) {
                if (setHoverProductImage === "") {
                    isHover = false;
                }
                isHover === false ? imagestmp.push(setDefaultProductImage) : imagestmp.push(setHoverProductImage);
            }
        } else {
            imagestmp = [
                "MissingImage"
            ];
        }
        if (mapImageToColor && currFilters) {
            const colorFilter = currFilters.find((q)=>(0,helper/* isColorFacet */.B3G)(q.facet));
            const selColors = colorFilter === null || colorFilter === void 0 ? void 0 : colorFilter.value;
            if ((selColors === null || selColors === void 0 ? void 0 : selColors.length) > 0) {
                let selectedProductImage = "";
                var ref;
                let i = (ref = (selColors === null || selColors === void 0 ? void 0 : selColors.length) - 1) !== null && ref !== void 0 ? ref : 0;
                let variantPriceTmp = 0;
                let variantDiscPriceTmp = 0;
                while(!selectedProductImage && i >= 0){
                    const colorName = selColors[i];
                    if (colorDetail === null || colorDetail === void 0 ? void 0 : colorDetail.length) {
                        var ref1, ref2;
                        var ref3;
                        const exactSKUDetails = (ref3 = (ref1 = colorDetail.find((item)=>item.split("|")[1] === colorName)) === null || ref1 === void 0 ? void 0 : ref1.split("|")) !== null && ref3 !== void 0 ? ref3 : [];
                        setSelColor(selColors[i]);
                        var ref4;
                        const productId = (ref4 = (ref2 = exactSKUDetails[5]) === null || ref2 === void 0 ? void 0 : ref2.split("?")[0].split("/").slice(-1)) !== null && ref4 !== void 0 ? ref4 : [];
                        var ref5;
                        selectedProductImage = (ref5 = productId[0]) !== null && ref5 !== void 0 ? ref5 : "";
                        var ref6;
                        variantPriceTmp = (ref6 = exactSKUDetails[2]) !== null && ref6 !== void 0 ? ref6 : 0;
                        var ref7;
                        variantDiscPriceTmp = (ref7 = exactSKUDetails[3]) !== null && ref7 !== void 0 ? ref7 : 0;
                    }
                    i--;
                }
                setVariantPrice(variantPriceTmp);
                setVariantDiscPrice(variantDiscPriceTmp);
                if (!selectedProductImage) selectedProductImage = "MissingImage";
                if (imagestmp[0] === imagestmp[1]) {
                    imagestmp = [
                        selectedProductImage,
                        selectedProductImage
                    ];
                } else {
                    imagestmp[0] = selectedProductImage;
                }
            }
        }
        setImages(imagestmp);
        if (selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.sku) {
            setSelected({
                sku: (selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.sku) ? selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.sku : sku
            });
        }
        let colorsTemp = [];
        if (data["Color.SKU.Details_ss"]) {
            colorsTemp = data["Color.SKU.Details_ss"].map((color)=>{
                const d = color.split("|");
                return {
                    name: d[0],
                    swatch: d[1],
                    sku: d[2],
                    isStock: d[3],
                    isDiscontinued: d[4],
                    customerFacingSKU: d[5]
                };
            });
        }
        const colorsTempVal = colorsTemp.filter((item)=>{
            var ref;
            return ((ref = item.swatch) === null || ref === void 0 ? void 0 : ref.toLowerCase()) !== constants.SWATCH_NA.toLowerCase() && (item.isDiscontinued === "false" || Date.parse(item.isDiscontinued) > Date.now());
        });
        setColors(colorsTempVal);
        const { Tile_Title: tileTitle = "" , Collapse_Title_s: collapseTitles = "" , productName_s: productNames = "" , RegionBrandName_s: regionBrandNames = "" , ProductBrandName_s: productBrandName = "" , ProductDescriptionProductShort_s: productDescriptionProductShort = ""  } = data;
        setTileTitle(tileTitle);
        setProductName(isGrouped ? collapseTitles : (type === null || type === void 0 ? void 0 : type.toLowerCase()) === "parts" ? productNames : productBrandName || regionBrandNames || productNames);
        setProductDescription(productDescriptionProductShort);
        if (isSterling && sterlingData.length > 0) {
            setProductName(sterlingData[0].ProductBrandName_s);
        }
        setDescription(isGrouped ? get_default()(data, "Collapse_Description_s", "") : get_default()(data, "ProductDescriptionProductShort_s", ""));
        var _ProductLocalCategory_s;
        setCategory(data.Product_Category ? data.Product_Category : (_ProductLocalCategory_s = data.ProductLocalCategory_s) !== null && _ProductLocalCategory_s !== void 0 ? _ProductLocalCategory_s : "");
        setShipmentDate(get_default()(data, "RegionLaunchDate_dt", ""));
        setBadgeVal(get_default()(data, "priceList.".concat(persona, ".saleOffer_s"), ""));
        setDiscountedPrice(get_default()(data, "priceList.".concat(persona, ".finalPrice_d"), 0));
        setFinalPrice(get_default()(data, "priceList.".concat(persona, ".price_d"), 0));
        if (isSterling) {
            setFinalPrice(sterlingData[0]["priceList.".concat(persona, ".finalPrice_d")]);
        }
        setPrice(get_default()(data, "priceStartingAt.".concat(persona, "_d"), 0));
        setIsFavorite((favorites === null || favorites === void 0 ? void 0 : favorites.find((vl)=>vl.productId === data["ctId_s"])) ? true : false);
        setIsDiscountedPrice(get_default()(data, "priceList.".concat(persona, ".discountedPrice_d"), 0));
        setDiscountPercent(badgeVal && isDiscountedPrice ? 100 - Math.round(isDiscountedPrice / price * 100) : 0);
        setDiscountPriceState(badgeVal && isDiscountedPrice ? "percentOff|" + discountPercent : "regular price");
        setProductIsRetail(get_default()(data, "ProductIsRetail", "") === "true" ? true : false);
        setIsSuperSku(get_default()(data, "comboSKUAvailable_b", null) ? true : false);
        setDiscountAmount(discountPercent ? Number((price - isDiscountedPrice).toFixed(2)) : 0);
        setProductRoom(get_default()(data, "category1_s", "n/a"));
        setProductCollectionsName(get_default()(data, "ProductBrandNameDisplay_s", "n/a"));
    }, [
        sku,
        data,
        mapImageToColor,
        currFilters,
        isGrouped,
        favorites,
        hoverColor,
        colorDetail
    ]);
    // Update price on hover
    (0,react.useEffect)(()=>{
        if (!sku) {
            return;
        }
        if (isGrouped) {
            setFinalPrice(get_default()(data, "min_price", 0));
            setMaxPrice(get_default()(data, "max_price", 0));
            setDiscountedPrice(get_default()(data, "disc_min_price", 0));
            setDiscountedMaxPrice(get_default()(data, "disc_max_price", 0));
        } else if (mapImageToColor && (selColor || hoverColor) && variantPrice > 0) {
            setFinalPrice(variantPrice);
            setDiscountedPrice(variantDiscPrice);
        } else if (exactSKU) {
            var ref;
            const exactSKUDetails = (ref = colorDetail.find((item)=>item.split("|")[0] === sku).split("|")) !== null && ref !== void 0 ? ref : [];
            var ref1;
            setFinalPrice((ref1 = exactSKUDetails[2]) !== null && ref1 !== void 0 ? ref1 : 0);
            var ref2;
            setDiscountedPrice((ref2 = exactSKUDetails[3]) !== null && ref2 !== void 0 ? ref2 : 0);
        }
    }, [
        data,
        hoverColor,
        selColor,
        variantPrice,
        exactSKU,
        sku,
        mapImageToColor,
        isGrouped,
        colorDetail,
        variantDiscPrice
    ]);
    (0,react.useEffect)(()=>{
        if (isMobile) {
            setBadgesList(displayOrderBadgeList.slice(0, 2));
        } else {
            setBadgesList(displayOrderBadgeList);
        }
    }, [
        isMobile
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(general)) {
            (0,helper/* getPDPUrlForProductTile */.Aut)(data).then((ret)=>setTileUrl(ret));
        }
    }, [
        general,
        data
    ]);
    (0,react.useEffect)(()=>{
        setDefaultImageTmp(images.length ? images[0] : "");
    }, [
        images
    ]);
    (0,react.useEffect)(()=>{
        var ref, ref1;
        if (mapImageToColor && selColor && selColor !== "Not Applicable") {
            var ref2;
            const selColorDetails = (ref2 = colors.find((item)=>item.name === selColor)) !== null && ref2 !== void 0 ? ref2 : {};
            setSelSku(selColorDetails === null || selColorDetails === void 0 ? void 0 : selColorDetails.sku);
            setSelCustomerFacingSKU(selColorDetails === null || selColorDetails === void 0 ? void 0 : selColorDetails.customerFacingSKU);
        } else {
            const currentSku = selectedColor && selectedColor.sku ? selectedColor.sku : sku;
            setSelSku(currentSku);
            setSelCustomerFacingSKU(masterCustomerFacingSku);
        }
        setDetaultSelectedColor(colors.length ? (ref = colors[0]) === null || ref === void 0 ? void 0 : ref.name : "");
        setDefaultCustomerFacingSku(colors.length ? (ref1 = colors[0]) === null || ref1 === void 0 ? void 0 : ref1.customerFacingSKU : "");
        setDefaultProductIsInStock(colors.length ? colors[0].isStock === "true" || colors[0].isStock === true : false);
        setProductSaleable(productIsRetail || !colors.length ? false : true);
    }, [
        mapImageToColor,
        masterCustomerFacingSku,
        selColor,
        sku,
        colors,
        productIsRetail
    ]);
    (0,react.useEffect)(()=>{
        setColorCount(swatchCount !== null && swatchCount !== void 0 ? swatchCount : 7);
    }, [
        swatchCount
    ]);
    const [pageRedirectUrl, setPageRedirectUrl] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        const pageredirectUrlVal = (type === null || type === void 0 ? void 0 : type.toLowerCase()) === "parts" ? "".concat(tileUrl).concat(selSku ? "?skuId=" + selSku : "?skuId=" + sku) : "".concat(tileUrl).concat(selSku ? "?skuId=" + selSku : "");
        setPageRedirectUrl(pageredirectUrlVal);
    }, [
        data,
        type,
        tileUrl,
        selSku
    ]);
    const cartData = (0,es/* useSelector */.v9)((state)=>state.cart.data);
    // Update image on Hover
    const setSelected = (color)=>{
        var ref, ref1;
        var ref2;
        const skuDetails = (ref2 = (ref = colorDetail.find((item)=>item.split("|")[0] === color.sku)) === null || ref === void 0 ? void 0 : ref.split("|")) !== null && ref2 !== void 0 ? ref2 : [];
        var ref3;
        const productId = (ref3 = (ref1 = skuDetails[5]) === null || ref1 === void 0 ? void 0 : ref1.split("?")[0].split("/").slice(-1)) !== null && ref3 !== void 0 ? ref3 : [];
        var ref4;
        const selProdImage = (ref4 = productId[0]) !== null && ref4 !== void 0 ? ref4 : "MissingImage";
        let imgValSelected = images;
        if (imgValSelected[0] === imgValSelected[1]) {
            imgValSelected = [
                selProdImage,
                selProdImage
            ];
        } else {
            imgValSelected[0] = selProdImage;
        }
        setImages(imgValSelected);
        if (!isGrouped) {
            var ref5;
            setVariantPrice((ref5 = skuDetails[2]) !== null && ref5 !== void 0 ? ref5 : 0);
            var ref6;
            setVariantDiscPrice((ref6 = skuDetails[3]) !== null && ref6 !== void 0 ? ref6 : 0);
        }
    };
    (0,react.useEffect)(()=>{
        if (hoverColor) {
            setSelected(hoverColor);
        } else if (selectedColor) {
            setSelected(selectedColor);
        }
    }, [
        hoverColor
    ]);
    (0,react.useEffect)(()=>{
        const compareSku = selSku !== "" ? selSku : sku;
        if (comparedProducts.find((prod)=>prod.compareSku === compareSku)) {
            setIsChecked(true);
        } else {
            setIsChecked(false);
        }
    }, [
        comparedProducts,
        data,
        selSku,
        sku
    ]);
    (0,react.useEffect)(()=>{
        setHoverColor("");
        setSelectedColor("");
    }, [
        currFilters,
        selectedSort
    ]);
    const colorSwatchDefaultImg = (e)=>{
        e.target.src = swatch_missing/* default.src */.Z.src;
    };
    const handleCompare = (event, sku)=>{
        setIsChecked(!isChecked);
        if (event.target.checked) {
            let variantFlag = false;
            if (comparedProducts.length < 4) {
                const allVariantSkus = comparedProducts === null || comparedProducts === void 0 ? void 0 : comparedProducts.map((a)=>{
                    const variantSkus = a["variantList.sku_ss"] || [];
                    return [
                        ...variantSkus,
                        a.masterSKU_s || a.sku_s
                    ].filter(Boolean);
                }).flat();
                if (allVariantSkus === null || allVariantSkus === void 0 ? void 0 : allVariantSkus.includes(sku)) {
                    variantFlag = true;
                }
                if (compareCategory !== "" && compareCategory !== productCategory) {
                    setErrorMessage(texts.sameCategory);
                    setTimeout(()=>{
                        setErrorMessage("");
                    }, 2000);
                    setIsChecked(false);
                    removeFromCompare(sku);
                } else {
                    addToCompare(sku, data, general === null || general === void 0 ? void 0 : general.lwAppName, persona, compareSectionData);
                }
            } else if (variantFlag && "compare_products_v1" === "compare_products_v2") {} else {
                setErrorMessage(texts.maxProduct);
                setTimeout(()=>{
                    setErrorMessage("");
                }, 2000);
                setIsChecked(false);
                removeFromCompare(sku);
            }
        } else {
            removeFromCompare(sku);
        }
        handleAnalytics("compare");
    };
    const handleAnalytics = (type)=>{
        try {
            const { adobeDataLayer: { getState  } = {}  } = window;
            const page = getState && getState("page") || {};
            const eventInfo = getEventInfo(type, null, true);
            const productInfo = getProductInfo(selectedColor, true);
            window.adobeDataLayer.push({
                event: "cmp:click",
                page,
                eventInfo,
                productInfo
            });
        } catch (err) {
            console.log(err);
        }
    };
    const handleLogin = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        window.loginFavouriteCallback = ()=>{
            setLoginFavouriteCallback(e);
        };
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
    };
    const handleShare = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        setShowShare(true);
        handleAnalytics("share");
    };
    const redirectPDP = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        let redirectUrl;
        router.push(decodeURIComponent(pageRedirectUrl));
        window.history.replaceState(window.location.pathname, document.title, window.location.href.includes("?") ? "".concat(window.location.search, "&back=").concat(masterCustomerFacingSku) : "?back=".concat(masterCustomerFacingSku));
        if (isSterling) {
            if (parent.toLowerCase() === "utility widgets") {
                redirectUrl = (0,helper/* sanitizeUrl */.Nmg)(window.location.origin + searchPagePath + "?keyword=".concat(sterlingData[0].sku_s));
                window.location.href = redirectUrl;
            }
        }
        if (isSearchPanelTile) {
            onToggle();
        }
    };
    const handleMouseLeave = ()=>{
        onHover && setOnHover(false);
        setShowShare(false);
    };
    const handlehoverImgFunction = ()=>{
        try {
            const hoverImgLists = document.querySelectorAll("#kf-product-list-tile-wrapper-".concat(data["ctId_s"], " img.product-list-tile__hoverimg"));
            if (hoverImgLists.length > 0) {
                const hoverImg = hoverImgLists[0];
                const hoverSrc = hoverImg.getAttribute("imgsrc");
                const hoverSrcAlt = hoverImg.getAttribute("imgalt");
                hoverImg.src = hoverSrc;
                hoverImg.alt = hoverSrcAlt;
            }
        } catch (error) {
            console.log(error);
        }
    };
    const handleMouseEnter = ()=>{
        handlehoverImgFunction() && setOnHover(true);
    };
    const handleTouchStart = ()=>{
        handlehoverImgFunction() && setOnHover(true);
    };
    const handleTouchEnd = ()=>{
        onHover && setOnHover(false);
        setShowShare(false);
    };
    const presetConf = JSON.parse(presetConfigs || searchPresetConfigs);
    const getEventInfo = function(type, color) {
        let needsJSON = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isForSample = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, sterling = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        /**
     * type is default navigation, could be favorite or share
     * color is optional, could be selected color from plp or search page product
     * needsJSON returns either JSON or stringified value
     */ let alternameType;
        let compareInternalLinkName;
        if (type === "favorite") {
            if (isFavorite) {
                alternameType = "favorite remove";
            } else {
                alternameType = "favorite add";
            }
        } else if (type === "compare") {
            if (isChecked) {
                alternameType = "compare remove";
                compareInternalLinkName = "remove compare";
            } else {
                alternameType = "compare add";
                compareInternalLinkName = "add to compare";
            }
        }
        let selectedTab;
        let pageSection;
        if (favPage && selectedtab) {
            pageSection = "favorites";
            selectedTab = selectedtab.toLowerCase();
        }
        const plpPrefix = isForSample ? "plp:sample" : "plp";
        const selectedTabForSearchResults = type || "products";
        const colorSelection = color ? "color selection" : alternameType || (0,helper/* sanitizeTextForAnalytics */.T68)(type || productName + " " + description);
        const eventInfo = {
            eventAction: "".concat(pageSection ? "my account:" + pageSection + ":" : plpPage ? plpPrefix : "search results", " product ").concat(alternameType || type || "navigation"),
            eventName: "".concat(pageSection ? "my account:" + pageSection + ":" : plpPage ? plpPrefix : "search results", " product ").concat(alternameType || type || "navigation"),
            eventType: isForSample || type === "favorite" ? "wishlist save" : "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: sterling ? "view sterling results" : type === "compare" ? compareInternalLinkName : colorSelection,
            internalLinkPosition: selectedTab !== null && selectedTab !== void 0 ? selectedTab : plpPage ? plpPrefix : "search results",
            internalLinkType: pageSection ? "my accounts:navigation" : "".concat(plpPage ? plpPrefix : "search results", ":").concat(type || (plpPage ? "navigation" : "product tiles")),
            internalLinkZoneName: selectedTab ? "my account:".concat(pageSection, ":").concat(selectedTab, ":main content area") : plpPage ? "".concat(plpPrefix, ":promo tiles") : "search results:".concat(selectedTabForSearchResults, ":main content area"),
            internalLinkURL: isSterling ? window.location.href : !type ? ((tileUrl === null || tileUrl === void 0 ? void 0 : tileUrl.indexOf("http")) === -1 ? window.location.origin : "") + tileUrl + (color ? "?skuId=" + color.sku : selSku ? "?skuId=" + selSku : "") : "n/a",
            clickInternalLinks: "true"
        };
        if (needsJSON) {
            return eventInfo;
        }
        return JSON.stringify(eventInfo);
    };
    const getProductInfo = function(color) {
        let needsJSON = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, sterling = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        var ref, ref1, ref2, ref3;
        const { productCouponCode , productCoupondiscount  } = (0,helper/* getCurrentSkuCouponDiscounts */.mPk)({
            cart: cartData,
            sku: sku,
            locale: locale
        });
        var ref4;
        const colorDetail = (ref4 = data["Color.SKU.Details_ss"]) !== null && ref4 !== void 0 ? ref4 : [];
        var ref5;
        const colorName = color ? (ref5 = (ref = colorDetail.find((item)=>item.split("|")[2] === color.sku)) === null || ref === void 0 ? void 0 : ref.split("|")[0]) !== null && ref5 !== void 0 ? ref5 : "" : "";
        var ref6;
        const inStock = color ? (ref6 = (ref1 = colorDetail.find((item)=>item.split("|")[2] === color.sku)) === null || ref1 === void 0 ? void 0 : ref1.split("|")[3]) !== null && ref6 !== void 0 ? ref6 : "" : "";
        const description = isGrouped ? get_default()(data, "Collapse_Description_s", "") : get_default()(data, "ProductDescriptionProductShort_s", "");
        const productIdFallback = defaultCustomerFacingSku || data["sku_s"] || data["masterSKU_s"] || ((ref2 = data["variantList.sku_ss"]) === null || ref2 === void 0 ? void 0 : ref2[0]);
        let productId = (color === null || color === void 0 ? void 0 : color.customerFacingSKU) || productIdFallback || "n/a";
        if (isSterling && sterlingData.length) {
            var ref7;
            var ref8;
            productId = (ref8 = (ref7 = sterlingData[0]) === null || ref7 === void 0 ? void 0 : ref7.sku_s) !== null && ref8 !== void 0 ? ref8 : "";
        }
        const productInfo = {
            productInfo: {
                productBrand: sterling ? "sterling" : general === null || general === void 0 ? void 0 : (ref3 = general.siteName) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(),
                description: (0,helper/* sanitizeTextForAnalytics */.T68)(description) || "n/a",
                globalPromotionPrice: discountPercent && discountAmount ? Number((price - discountAmount).toFixed(2)) : price,
                priceState: discountPriceState,
                productBasePrice: price,
                productCategory: (0,helper/* sanitizeTextForAnalytics */.T68)(category) || "n/a",
                productColor: (0,helper/* sanitizeTextForAnalytics */.T68)(colorName ? colorName : detaultSelectedColor) || "n/a",
                productID: productId,
                productName: (0,helper/* sanitizeTextForAnalytics */.T68)(productName) || "n/a",
                productRoom: (0,helper/* sanitizeTextForAnalytics */.T68)(productRoom || category) || "n/a",
                productSalePrice: discountedPrice ? discountedPrice : price,
                productSaleable: productSaleable,
                productStatus: color ? inStock === "true" || inStock === true ? "in stock" : "out of stock" : defaultProductIsInStock ? "in stock" : "out of stock",
                productSuperSku: isSuperSku,
                productTileName: (0,helper/* sanitizeTextForAnalytics */.T68)(tileTitle) || "n/a",
                defaultImageName: defaultImageTmp || "n/a",
                productCollectionsName: (0,helper/* sanitizeTextForAnalytics */.T68)(productCollectionsName || category) || "n/a",
                globalOffer: badgeVal ? badgeVal : "n/a",
                globalDiscount: discountPercent ? discountAmount : "n/a",
                productPartnerBuyNow: productIsRetail,
                pdpType: isBundleProduct ? "bundle" : "regular finished goods & service parts",
                productFindingMethod: "n/a",
                productCouponCode: productCouponCode.join("|") || "n/a",
                productCoupondiscount: productCoupondiscount,
                frequency: "n/a",
                isRecommended: "n/a",
                isSendNow: "n/a",
                isSubscription: "n/a",
                quantity: "n/a",
                ratings: "n/a",
                numberOfReviews: "n/a"
            }
        };
        if (needsJSON) {
            return productInfo.productInfo;
        }
        return JSON.stringify(productInfo);
    };
    const onSelectedColor = (e, color)=>{
        e.stopPropagation();
        const { sku , customerFacingSKU  } = color;
        setSelectedColor({
            sku: sku,
            customerFacingSKU: customerFacingSKU
        });
        setSelected({
            sku: sku,
            customerFacingSKU: customerFacingSKU
        });
        triggerAnalytics.current = true;
    };
    const colorClickHandler = (color)=>{
        triggerAnalytics.current = false;
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        const eventInfo = getEventInfo(null, color, true, false, false);
        const productInfo = getProductInfo(color, true);
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo,
            productInfo
        });
    };
    const checkColorFocus = (e, colors, index)=>{
        const colorSlice = colors.slice(0, colorCount);
        if (e.key === "Tab" && colorSlice.length - 1 === index || e.shiftKey && e.key === "Tab" && index === 0) {
            setHoverColor(selectedColor !== null && selectedColor !== void 0 ? selectedColor : "");
        }
    };
    const handleOnClickPartsDiagramLinkTmp = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        handleOnClickPartsDiagramLink(data);
        partsAnalytics();
    };
    const partsAnalytics = ()=>{
        try {
            const { adobeDataLayer: { getState  } = {}  } = window;
            const page = getState && getState("page") || {};
            const eventInfo = getEventInfo(partsDiagram.toLowerCase(), null, true, true);
            const productInfo = getProductInfo(selectedColor, true);
            window.adobeDataLayer.push({
                event: "cmp:click",
                page,
                eventInfo,
                productInfo
            });
        } catch (err) {
            console.log(err);
        }
    };
    const partsDiagram = t("kf.search.partsdiagram");
    const serviceParts = t("kf.search.serviceparts");
    const productTileClickHandler = async ()=>{
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        const eventInfo = getEventInfo("", null, true);
        const productInfo = getProductInfo(null, true);
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo,
            productInfo
        });
    };
    const viewSterlingResultsHandler = async ()=>{
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        const eventInfo = getEventInfo("", null, true, true, true);
        const productInfo = getProductInfo(null, true, true);
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo,
            productInfo
        });
    };
    const getDivProps = ()=>isSterling ? {} : {
            onClick: debounce_default()(productTileClickHandler, 500)
        };
    const renderBadge = (item)=>{
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: "product-list-tile__new",
            children: (ref = plpBadges[item]) === null || ref === void 0 ? void 0 : ref.value
        });
    };
    const tileDetails = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-list-tile__image wow",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: images.map((id, i)=>{
                        const imgUrl = (0,utils/* getPresetUrl */.v$)(width, rowCols, general.swatchUrl, id, presetConf);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            id: id + "_IMG_" + i,
                            role: "presentation",
                            src: isSterling ? data["productImage.url_ss"][0] : i === 0 ? imgUrl : images[0] != images[1] ? EMPTY_PIXEL : imgUrl,
                            className: classnames_default()({
                                "product-list-tile__image--hover test1": images.length > 1 && i === 0
                            }, {
                                "product-list-tile__hoverimg test2": images.length > 1 && i !== 0
                            }),
                            alt: data.metaTitle_s,
                            imgsrc: imgUrl,
                            imgalt: data.metaTitle_s,
                            onError: (e)=>(0,utils/* onImageError */.Ac)(e, imgUrl)
                        }, id + "_IMG_" + i);
                    })
                })
            }),
            !favPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-list-tile__share",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        id: "kf-add-to-fav-".concat(index),
                        className: "product-list-tile__share-icon",
                        tabIndex: "0",
                        "aria-label": t("kf.plp.label.wishlist", {
                            product: productName
                        }),
                        "aria-hidden": width > 1024 ? onHover ? false : true : false,
                        onClick: isAuth ? handleFavorite : handleLogin,
                        onFocus: ()=>{
                            setOnHover(true);
                        },
                        onBlur: ()=>{
                            setOnHover(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            role: "presentation",
                            src: isFavorite ? wishlist_gray_filled/* default.src */.Z.src : wish/* default.src */.Z.src,
                            alt: texts.wishlist
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "product-list-tile__share-icon-plp",
                        tabIndex: "0",
                        "aria-label": t("kf.plp.label.share.aria", {
                            product: productName
                        }),
                        "aria-hidden": width > 1024 ? onHover ? false : true : false,
                        onClick: handleShare,
                        onFocus: ()=>{
                            setOnHover(true);
                        },
                        onBlur: ()=>{
                            setOnHover(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            role: "presentation",
                            src: share/* default.src */.Z.src,
                            alt: texts.share
                        })
                    })
                ]
            }),
            " "
        ]
    });
    if (!(locale && locale !== "") && loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "product-list-tile--loading",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "loading-image shimmer"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "loading-title shimmer"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "loading-description shimmer"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "loading-swatch",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "shimmer"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "shimmer"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "shimmer"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "shimmer"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "shimmer"
                        })
                    ]
                })
            ]
        });
    }
    const handleColorClick = (e, color)=>{
        onSelectedColor(e, color);
    };
    const availabilityLabel = (0,helper/* getAvailabilityLabel */.F3C)(get_default()(data, "SKUAnnSacksNonStock_b", ""), general);
    const noBadge = get_default()(data, "noBadge_b", false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "kf-product-list-tile-wrapper-".concat(data["ctId_s"]),
        className: "product-list-tile__wrapper wow  ".concat(onHover && "--hover"),
        onFocus: ()=>{
            setOnHover(true);
        },
        onBlur: ()=>{
            setOnHover(false);
        },
        onMouseLeave: handleMouseLeave,
        onMouseEnter: handleMouseEnter,
        onTouchStart: handleTouchStart,
        onTouchEnd: handleTouchEnd,
        children: [
            isSterling && showSterlingButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "family-of-brands",
                children: staticText.familyResults
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSocialShare/* default */.Z, {
                showModal: showShare,
                id: "kf-plp-tile-".concat(data["ctId_s"]),
                url: window.location.origin + tileUrl,
                onClose: ()=>setShowShare(false),
                analyticData: getEventInfo("share", null, true),
                disableInstagram: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "Inner-".concat(masterCustomerFacingSku),
                role: "link",
                tabIndex: "0",
                className: "product-list-tile__wrapper__card",
                "aria-label": t("kf.plp.ariaLabel.productInfo", {
                    productName: productName,
                    description: description,
                    price: discountedPrice > 0 ? "Sale Price: ".concat(currencySign + " " + discountedPrice, " Original Price: ").concat(currencySign + " " + price) : "Price: ".concat(currencySign + " " + price)
                }),
                onFocus: (e)=>e.stopPropagation(),
                onClick: !(isSterling && parent.toLowerCase() === "search") ? redirectPDP : ()=>{},
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()({
                        "product-list-tile": true,
                        "product-list-tile--lite": lite
                    }),
                    children: [
                        isSterling && parent.toLowerCase() === "search" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                cursor: "default"
                            },
                            children: tileDetails
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            role: "link",
                            tabIndex: "-1",
                            href: "".concat(tileUrl, "?skuId=").concat(selSku !== "" ? selSku : sku),
                            onClick: debounce_default()(productTileClickHandler, 500),
                            children: tileDetails
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: isSterling && parent.toLowerCase() === "search" ? "product-list-tile__sterling" : "product-list-tile__details wow",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "product-list-tile__details product-list-tile__compare-main",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        ...getDivProps(),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                "aria-label": "".concat(colors.length).concat(texts.colorsLinkAria),
                                                className: "product-list-tile__colors",
                                                children: colors.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "product-list-tile__colors--swatch",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                                                            role: "radiogroup",
                                                            "aria-labelledby": "color-options-label",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                                                                    id: "color-options-label",
                                                                    className: "legend",
                                                                    children: "Color Options"
                                                                }),
                                                                colors.slice(0, colorCount).map((color, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                        htmlFor: "".concat(color.name, "-id"),
                                                                        onClick: (e)=>{
                                                                            handleColorClick(e, color);
                                                                        },
                                                                        role: "radio",
                                                                        tabIndex: "0",
                                                                        "aria-label": "".concat(color.name, " color"),
                                                                        "aria-checked": selectedColor.sku === color.sku,
                                                                        "aria-hidden": onHover ? false : true,
                                                                        rel: "noreferrer",
                                                                        title: color.name,
                                                                        className: classnames_default()({
                                                                            "product-list-tile__color-swatch": true,
                                                                            "selected-swatch": selectedColor.sku === color.sku
                                                                        }),
                                                                        onMouseEnter: ()=>{
                                                                            setHoverColor({
                                                                                sku: color.sku,
                                                                                customerFacingSKU: color.customerFacingSKU
                                                                            });
                                                                        },
                                                                        onMouseLeave: ()=>setHoverColor(selectedColor !== null && selectedColor !== void 0 ? selectedColor : {}),
                                                                        onFocus: ()=>{
                                                                            setHoverColor({
                                                                                sku: color.sku,
                                                                                customerFacingSKU: color.customerFacingSKU
                                                                            });
                                                                        },
                                                                        onKeyDown: (e)=>checkColorFocus(e, colors, i),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                type: "radio",
                                                                                id: "".concat(color.name, "-id"),
                                                                                "aria-label": "".concat(color.name),
                                                                                "aria-checked": selectedColor.sku === color.sku
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                role: "presentation",
                                                                                src: "".concat(general.swatchUrl).concat(color.swatch).concat(width <= 768 ? "?$PLPSwatch_Mobile50$" : "?$PLPSwatch_Desk100$"),
                                                                                alt: color.name,
                                                                                onError: (e)=>colorSwatchDefaultImg(e)
                                                                            })
                                                                        ]
                                                                    }, "color-".concat(color.sku, "-").concat(color.customerFacingSKU, "-").concat(i)))
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: colors.length > colorCount && "+" + (colors.length - colorCount)
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "product-tile__badge",
                                                    children: isSale && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "product-tile__new",
                                                        children: texts.sale
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classnames_default()({
                                                    "product-list-tile__info": true,
                                                    "mt-0": !colors.length
                                                }),
                                                children: [
                                                    !(general === null || general === void 0 ? void 0 : general.disableCommerce) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-list-tile__badge",
                                                        children: badgesList === null || badgesList === void 0 ? void 0 : badgesList.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                                children: [
                                                                    item.includes("new") && (0,helper/* showNewBadge */.ZTk)(shipmentDate) ? renderBadge(item) : null,
                                                                    item.includes("sale") && !isEmpty_default()(badgeVal) ? renderBadge(item) : null,
                                                                    item.includes("3d") ? renderBadge(item) : null,
                                                                    item.includes("exclusive") && data["ProductIsExclusive_s"] ? renderBadge(item) : null
                                                                ]
                                                            }, item))
                                                    }),
                                                    !noBadge && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-list-tile__shipping-status",
                                                        children: availabilityLabel
                                                    }),
                                                    productName && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                className: "product-list-tile__crawlableData",
                                                                children: data === null || data === void 0 ? void 0 : data.productName_s
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                "aria-label": productName,
                                                                className: "product-list-tile__title",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight/* default */.Z, {
                                                                    text: productName,
                                                                    highlight: highlightText
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight/* default */.Z, {
                                                                    text: productDescription,
                                                                    highlight: highlightText
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: finalPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    "aria-label": "".concat(texts.salePriceAria).concat(currencySign).concat(!(general === null || general === void 0 ? void 0 : general.disableCommerce) && discountedPrice > 0 ? discountedPrice : finalPrice !== null && finalPrice !== void 0 ? finalPrice : 0, "\n                                ").concat(isGrouped && (discountedPrice > 0 ? discountedPrice !== discountedMaxPrice : finalPrice !== maxPrice) ? " - " + currencySign + (discountedMaxPrice > 0 ? discountedMaxPrice : maxPrice) : ""),
                                                    className: "product-list-tile__price ".concat(!isGrouped && "product-list-tile_paddingtop"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                            value: !(general === null || general === void 0 ? void 0 : general.disableCommerce) && discountedPrice > 0 ? parseFloat(discountedPrice) : parseFloat(finalPrice !== null && finalPrice !== void 0 ? finalPrice : 0),
                                                            displayType: "text",
                                                            thousandSeparator: true,
                                                            prefix: currencySign,
                                                            decimalScale: 2,
                                                            fixedDecimalScale: true
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                unit,
                                                                " "
                                                            ]
                                                        }),
                                                        isGrouped && (!(general === null || general === void 0 ? void 0 : general.disableCommerce) && discountedPrice > 0 ? discountedPrice !== discountedMaxPrice : finalPrice !== maxPrice) && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                            value: discountedMaxPrice > 0 ? parseFloat(discountedMaxPrice) : parseFloat(maxPrice !== null && maxPrice !== void 0 ? maxPrice : 0),
                                                            displayType: "text",
                                                            thousandSeparator: true,
                                                            prefix: " - ".concat(currencySign),
                                                            decimalScale: 2,
                                                            fixedDecimalScale: true
                                                        }),
                                                        !(general === null || general === void 0 ? void 0 : general.disableCommerce) && discountedPrice !== finalPrice && discountedPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            "aria-label": "".concat(texts.originalPriceAria).concat(currencySign).concat(finalPrice !== null && finalPrice !== void 0 ? finalPrice : 0).concat(isGrouped && finalPrice !== maxPrice ? " - " + currencySign + discountedMaxPrice : ""),
                                                            className: classnames_default()({
                                                                "product-list-tile__discount-price": true,
                                                                "pl-0 d-block": isGrouped && width <= 480 && rowCols === 2
                                                            }),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                    value: parseFloat(finalPrice !== null && finalPrice !== void 0 ? finalPrice : 0),
                                                                    displayType: "text",
                                                                    thousandSeparator: true,
                                                                    prefix: currencySign,
                                                                    decimalScale: 2,
                                                                    fixedDecimalScale: true
                                                                }),
                                                                isGrouped && finalPrice !== maxPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                    value: parseFloat(maxPrice),
                                                                    displayType: "text",
                                                                    thousandSeparator: true,
                                                                    prefix: " - ".concat(currencySign),
                                                                    decimalScale: 2,
                                                                    fixedDecimalScale: true
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    !isSterling && !primaryBundleSKUs ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "product-list-tile__right-controls",
                                        children: [
                                            !hideCompare && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                onClick: (e)=>e.stopPropagation(),
                                                className: "product-list-tile__compare ".concat(lib/* isTablet */.Em ? "product-list-tile__compare-tablet" : ""),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                        id: "kf-checkbox-".concat(selSku !== "" ? selSku : sku),
                                                        index: index,
                                                        value: texts.addToCompare,
                                                        aria: "".concat(description, " ").concat(texts.addToCompare),
                                                        checked: isChecked,
                                                        onChange: (e)=>handleCompare(e, selSku !== "" ? selSku : sku),
                                                        disabled: isEnable
                                                    }),
                                                    errorMessage !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                                        message: errorMessage
                                                    })
                                                ]
                                            }),
                                            isPartsDiagramLinkVisible && Boolean(get_default()(data, "ProductProductNo_s", "")) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classnames_default()({
                                                    "product-tile__wrapper__card__parts": true,
                                                    "product-tile__wrapper__card__parts--lite": lite,
                                                    "product-tile__wrapper__card__parts--no-compare": isGrouped || hideCompare
                                                }),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "#",
                                                    className: "product-parts__viewer",
                                                    role: "link",
                                                    tabIndex: "0",
                                                    "aria-label": serviceParts,
                                                    rel: "noreferrer",
                                                    title: serviceParts,
                                                    onClick: (e)=>handleOnClickPartsDiagramLinkTmp(e),
                                                    children: serviceParts
                                                })
                                            })
                                        ]
                                    }) : null
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var v2_ProductTile = (/*#__PURE__*/react.memo(ProductTile));


/***/ }),

/***/ 67098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27514);
/* harmony import */ var _utils_location__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78800);
/* harmony import */ var _components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82476);
/* harmony import */ var _components_core_Image_DynamicImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96702);
/* harmony import */ var _components_PromoBanner_v1_index_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1745);
/* harmony import */ var _components_PromoBanner_v1_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_components_PromoBanner_v1_index_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _components_PromoBanner_v2_promoBannerHelper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84744);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47956);









const PromoBanner = (props)=>{
    var ref, ref1, ref2;
    const { setPromoData =()=>{} , xfLink ="" , col =0 , position =0 , width =0 , promoJson ={} , promoIndex =0 , parent ="" , onFilter =()=>{}  } = props;
    const [data, setData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        imgUrl: "",
        desc: "",
        ctaText: "",
        ctaLink: "",
        position: "",
        promoBg: "",
        fontColor: "inherit"
    });
    const [dynamicId, setDynamicId] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const promoDesc = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const buttonStyle = {
        color: data.fontColor,
        borderColor: data.fontColor
    };
    const [actionLink, setActionLink] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        getXfData();
    }, [
        xfLink,
        width
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (data === null || data === void 0 ? void 0 : data.desc) {
            const dynamicId = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .createIdFromString */ .ZT_)(data === null || data === void 0 ? void 0 : data.desc);
            setDynamicId(dynamicId);
        }
    }, [
        data === null || data === void 0 ? void 0 : data.desc
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (data === null || data === void 0 ? void 0 : data.ctaLink) {
            (0,_utils_location__WEBPACK_IMPORTED_MODULE_3__/* .getShortenedUrl */ .Pp)(data === null || data === void 0 ? void 0 : data.ctaLink).then((res)=>setActionLink(res));
        }
    }, [
        data
    ]);
    const setPromoJsonData = async function() {
        let jsonData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        if (jsonData) {
            var _ctaLink;
            const shortenedCtaLink = await (0,_utils_location__WEBPACK_IMPORTED_MODULE_3__/* .getShortenedUrl */ .Pp)((_ctaLink = jsonData.ctaLink) !== null && _ctaLink !== void 0 ? _ctaLink : "");
            var _imageUrl, _title, _ctaLabel, _ctaLabel1, _title1, _assetPath, ref, _fontColor;
            const result = {
                imgUrl: (_imageUrl = jsonData.imageUrl) !== null && _imageUrl !== void 0 ? _imageUrl : "",
                desc: (_title = jsonData.title) !== null && _title !== void 0 ? _title : "",
                altText: jsonData.isDecorativeTeaser !== "true" ? jsonData.altText : "",
                ctaText: (_ctaLabel = jsonData.ctaLabel) !== null && _ctaLabel !== void 0 ? _ctaLabel : "",
                ctaLink: (shortenedCtaLink === null || shortenedCtaLink === void 0 ? void 0 : shortenedCtaLink.includes(".html")) ? shortenedCtaLink : "".concat(shortenedCtaLink, ".html"),
                ctaAriaLabel: "".concat((_ctaLabel1 = jsonData.ctaLabel) !== null && _ctaLabel1 !== void 0 ? _ctaLabel1 : "", " ").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeText */ .oOy)((_title1 = jsonData.title) !== null && _title1 !== void 0 ? _title1 : "")),
                assetPath: (_assetPath = jsonData.assetPath) !== null && _assetPath !== void 0 ? _assetPath : "",
                position: position,
                infoTextAlign: (ref = width > 1023 ? jsonData.contentPosition : jsonData.mobileContentPosition) !== null && ref !== void 0 ? ref : "dead-center",
                promoBg: getGradiant(jsonData),
                fontColor: (_fontColor = jsonData.fontColor) !== null && _fontColor !== void 0 ? _fontColor : "inherit",
                isNewTab: jsonData.isNewTab === "true",
                isBannerLink: jsonData.linkAll === "true",
                isSmartCrop: jsonData.presetType === "smartcrop"
            };
            setData(result);
            if (setPromoData) {
                setPromoData(result);
            }
        } else if (setPromoData) {
            setPromoData({
                position: position
            });
        }
    };
    const getXfData = async ()=>{
        if (promoJson && Object.keys(promoJson).length > 0) {
            setPromoJsonData(promoJson);
        } else {
            const link = xfLink === null || xfLink === void 0 ? void 0 : xfLink.split(".html")[0];
            if (link) {
                try {
                    const data = await (0,_components_PromoBanner_v2_promoBannerHelper__WEBPACK_IMPORTED_MODULE_6__/* .getPromoData */ .G)(link);
                    setPromoJsonData(data);
                } catch (error) {
                    console.error(error);
                }
            }
        }
    };
    const getGradiant = (promoRes)=>{
        const gradientData = width > 767 & width < 1024 ? Array.isArray(promoRes.mobileGradientPosition) ? promoRes.mobileGradientPosition : [
            promoRes.mobileGradientPosition
        ] : Array.isArray(promoRes.gradientPosition) ? promoRes.gradientPosition : [
            promoRes.gradientPosition
        ];
        let gradientBg = "";
        let gradientPos = "";
        const toColor = "".concat(promoRes.opacityColor).concat(Math.floor((width > 767 ? promoRes.gradientOpacity : promoRes.tintOverlayValue) / 100 * 255).toString(16).padStart(2, 0));
        if (width > 767) {
            gradientData === null || gradientData === void 0 ? void 0 : gradientData.forEach((pos, i)=>{
                if (pos === "topToBottom") {
                    gradientPos = "to bottom";
                } else if (pos === "bottomToTop") {
                    gradientPos = "to top";
                } else if (pos === "leftToRight") {
                    gradientPos = "to right";
                } else if (pos === "radialCenterOut") {
                    gradientPos = "circle";
                }
                gradientBg = gradientBg + (i > 0 ? ", " : "") + "".concat(pos === "radialCenterOut" ? "radial-gradient" : "linear-gradient", "(").concat(gradientPos, ", ").concat(promoRes.opacityColor + "00", " 0%, ").concat(toColor, " 100%)");
            });
        } else {
            gradientBg = toColor;
        }
        return gradientBg !== "" ? gradientBg : "rgba(0,0,0,0)";
    };
    const onBannerClick = (event)=>{
        if (data.isBannerLink) {
            handlePromoBannerClick(event, data);
            window.open(data.ctaLink, data.isNewTab ? "_blank" : "");
        }
    };
    const ctatitle = data === null || data === void 0 ? void 0 : (ref = data.ctaText) === null || ref === void 0 ? void 0 : ref.toLowerCase();
    let eventInfo;
    if ((ref1 = window.location) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pathname) === null || ref2 === void 0 ? void 0 : ref2.includes("search")) {
        eventInfo = {
            eventAction: "search results:products:main content area:".concat(ctatitle),
            eventName: "search results:products:main content area:".concat(ctatitle),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: ctatitle,
            internalLinkPosition: "search",
            internalLinkType: "search results:internal campaign",
            internalLinkZoneName: "search results:products:main content area",
            internalLinkURL: window.location.origin + data.ctaLink,
            clickInternalLinks: "true"
        };
    } else if ((parent === null || parent === void 0 ? void 0 : parent.toLowerCase()) === _constants_index__WEBPACK_IMPORTED_MODULE_7__.dynamicSearch) {
        eventInfo = {
            eventAction: "search results:products:main content area:".concat(ctatitle),
            eventName: "search results:products:main content area:".concat(ctatitle),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: ctatitle,
            internalLinkPosition: "suggested search",
            internalLinkType: "suggested search results:internal campaign",
            internalLinkZoneName: "suggested search results:top products results",
            internalLinkURL: window.location.origin + data.ctaLink,
            clickInternalLinks: "true"
        };
    } else {
        eventInfo = {
            eventAction: "plp:".concat(ctatitle),
            eventName: "plp:".concat(ctatitle),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: ctatitle,
            internalLinkPosition: "plp",
            internalLinkType: "plp:internal campaign",
            internalLinkZoneName: "plp:promo tiles",
            internalLinkURL: window.location.origin + data.ctaLink,
            clickInternalLinks: "true"
        };
    }
    const scrollToTop = ()=>{
        const scrollStep = -window.scrollY / (1000 / 15 // scroll speed here
        );
        const scrollInterval = setInterval(()=>{
            if (window.scrollY !== 0) {
                window.scrollBy(0, scrollStep);
            } else {
                clearInterval(scrollInterval);
            }
        }, 15);
    };
    const handlePromoBannerClick = function(event) {
        let data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        onFilter([]);
        actionLink === window.location.pathname ? scrollToTop() : "";
        event.stopPropagation();
        if (window.adobeDataLayer) {
            var ref;
            const { adobeDataLayer: { getState  } = {}  } = window;
            const page = getState && getState("page") || {};
            const componentInfo = {
                componentID: window.location.href,
                componentLocation: window.location.pathname.includes("search") ? "search results:promo tiles" : "plp:promo tiles",
                componentMessage: "promo-".concat(promoIndex),
                componentName: (ref = data === null || data === void 0 ? void 0 : data.desc.replace(/<\/?[^>]+(>|$)/g, " ").replace(/(\r\n|\n|\r)/gm, "").replace(/&nbsp;/g, " ")) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                componentType: "internal campaign"
            };
            const eventDetails = {
                event: "cmp:click",
                eventInfo,
                componentInfo,
                page
            };
            window.adobeDataLayer.push(eventDetails);
        }
    };
    var _fontColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_components_PromoBanner_v1_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().productPromoBanner)),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "plp-promo-banner wow animate__fadeInUp ".concat(col === 2 || col === 3 ? "--fixed-height" : ""),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                role: data.isBannerLink ? "link" : "",
                tabIndex: data.isBannerLink ? 0 : -1,
                onClick: onBannerClick,
                className: "plp-promo-banner__layout --col-".concat(col !== null && col !== void 0 ? col : 1),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "plp-promo-banner__image",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Image_DynamicImage__WEBPACK_IMPORTED_MODULE_5__["default"], {
                            imgUrl: data === null || data === void 0 ? void 0 : data.imgUrl,
                            alt: data === null || data === void 0 ? void 0 : data.desc,
                            uniqueId: dynamicId
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "plp-promo-banner__info-bg",
                        style: {
                            background: "".concat(data.promoBg)
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "plp-promo-banner__info plp-promo-banner__info-".concat(data.infoTextAlign),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                ref: promoDesc,
                                className: "plp-promo-banner__desc",
                                style: {
                                    color: "".concat((_fontColor = data.fontColor) !== null && _fontColor !== void 0 ? _fontColor : "")
                                },
                                children: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .nbspSanitizeInnerHtml */ .E9Q)(data.desc)
                            }),
                            actionLink !== "" && (actionLink === window.location.pathname ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "plp-promo-banner__button",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    role: "button",
                                    customClass: "plp-promo-banner__cta",
                                    type: "ghost",
                                    size: "small",
                                    label: data.ctaText,
                                    ariaLabel: data.ctaAriaLabel,
                                    onClick: (event)=>handlePromoBannerClick(event, data),
                                    style: buttonStyle,
                                    useDefaultClass: true
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "plp-promo-banner__button",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    role: "link",
                                    customClass: "plp-promo-banner__cta",
                                    type: "ghost",
                                    size: "small",
                                    to: actionLink,
                                    label: data.ctaText,
                                    ariaLabel: data.ctaAriaLabel,
                                    onClick: (event)=>handlePromoBannerClick(event, data),
                                    style: buttonStyle,
                                    useDefaultClass: true
                                })
                            }))
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PromoBanner);


/***/ }),

/***/ 20711:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productTileWrapper":"ProductTile_productTileWrapper__slRQS"};

/***/ }),

/***/ 1745:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productPromoBanner":"v1_productPromoBanner__UEqVf"};

/***/ })

}]);